import {Component, Output, EventEmitter, OnInit, Renderer2, Inject} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {DOCUMENT} from '@angular/common';
import {AppConfigService, AutoDestroy} from '@ox/utils';
import {MapConfig} from '../../../../map/map.value';
import {SearchDealershipsWebuComponent} from '../../search-dealerships-webu.component';
import {GoogleMap} from '@gbds/core';
import {Store} from '@ngrx/store';
import {selectFeatureFlag} from '@ox/data';
import {UIFeatureFlag} from '@ox/typings';
import {Subject, takeUntil, tap} from 'rxjs';


const google = {
  get maps() {
    return window?.google?.maps as GoogleMap | any || null;
  }
};
@Component({
  selector: 'webu-search-dealerships',
  templateUrl: './kr-search-dealerships-webu.component.html'
})

export class KRSearchDealershipsWebuComponent extends SearchDealershipsWebuComponent implements OnInit {
  @Output() selectedSearchMethod = new EventEmitter();
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public disableScroll = false;
  public geolocationUnsupported = false;
  public searchMethod = 'city';
  public myLocationToggle$ = this.store.select(selectFeatureFlag({id: UIFeatureFlag.KOREA_DEALER_LOCATION, group: 'UI'}));

  constructor(
    private store: Store,
    fb: FormBuilder,
    appConfig: AppConfigService,
    @Inject(DOCUMENT) private document: Document) {
    super(
      fb,
      appConfig
    );
    this.dealerSearchForm = fb.group({
      brandSelectorInput: new FormControl('', [
        Validators.required
      ]),
      searchMethod: new FormControl('city', [
        Validators.required
      ]),
      searchInput: new FormControl('', [
        Validators.maxLength(this.searchAttributes.maxlength),
        Validators.required
      ])
    });
  }

  override ngOnInit(): void {
    this.setBrandsList();
    (window.gm as any).initAutoComplete = this._initAutoComplete;
    this.loadGoogleMaps();
  }

  override async search() {
    const input = (this.document.getElementById('DealerSearchLocateDealer') as HTMLInputElement).value;
    if (this.searchMethod === 'city') {
      const geocoder = new google.maps.Geocoder();
      try {
        await new Promise<void>((resolve, reject) => {
          geocoder.geocode({address: input, componentRestrictions: {country: this.appConfig.bml.market.toUpperCase()}}, (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
            if (status !== 'OK' && results === null) return reject('Bad Request');
            if (results[0].types.includes('country')) {
              return reject(`results for '${input}' not found in ${this.appConfig.bml.market}`);
            }
            return resolve();
          });
        });
      } catch (e) {
        this.searchChanged.emit('invalid');
        throw new Error('Geocoder failed due to: ' + e);
      }
    }
    this.brandSelected.emit(this.brandTranslator());
    this.selectedSearchMethod.emit(this.dealerSearchForm.controls['searchMethod'].value);
    this.searchChanged.emit(input);
  }

  searchType = (type: string): void => {
    this.dealerSearchForm.controls['searchMethod'].setValue(type);
    this.dealerSearchForm.controls['searchInput'].setValue('');
    this.searchMethod = type;
  };

  useMyLocation = (): void => {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = {
          lat: position.coords.latitude.toString(),
          lng: position.coords.longitude.toString()
        };
        this.brandSelected.emit(this.brandTranslator());
        this.selectedSearchMethod.emit('location');
        this.searchChanged.emit(pos.lat + ',' + pos.lng);
      });
    } else {
      this.geolocationUnsupported = true;
    }
  };

  loadGoogleMaps = (): void => {
    const regionPath =`&region=${this.appConfig.bml.market}&language=${this.appConfig.bml.lang}${this.appConfig.bml.market.toUpperCase()}`;
    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = MapConfig.googleMapsScriptUrl + regionPath + '&callback=gm.initAutoComplete';
    this.document.head.appendChild(script);
  };

  _initAutoComplete = (): void => {
    const input = this.document.getElementById('DealerSearchLocateDealer') as HTMLInputElement;
    const autocompleteCity = new google.maps.places.Autocomplete(
      input, {
      types: ['(cities)'],
      componentRestrictions: {country: this.appConfig.bml.market}
    });

    autocompleteCity.addListener('place_changed', () => {
      const cityName = autocompleteCity.getPlace().name;
      this.dealerSearchForm.controls['searchInput'].setValue(cityName);
    });

    const dealerModal = this.document.querySelector('.modal-content') as HTMLDivElement;
    dealerModal.addEventListener('wheel', (e) => {
      if (this.disableScroll) {
        e.preventDefault();
      }
      return;
    });

    setTimeout(() => {
      const resultsContainer = this.document.querySelector('.pac-container.pac-logo') as HTMLDivElement;
        if(resultsContainer) {
          resultsContainer.addEventListener('wheel', (e) => {
            e.preventDefault();
          });
        }
    }, 400);
  };

  public setScrolling = (status: boolean): void => {
    this.disableScroll = status;
  };

  override setBrandsList() {
    this.brands = ['쉐보레', '캐딜락', 'GMC'];

    if (this.activeVehicleMake) {
      this.dealerSearchForm.controls['brandSelectorInput'].setValue(this.isKoreanBrand(this.activeVehicleMake));
    }
    else {
      this.dealerSearchForm.controls['brandSelectorInput'].setValue(this.isKoreanBrand(this.currentBrand));
    }
  }

  brandTranslator() {
    switch (this.dealerSearchForm.controls['brandSelectorInput'].value) {
      case '쉐보레':
        return 'chevrolet';
      case '캐딜락':
        return 'cadillac';
      default:
        return 'gmc';
    }
  }

  isKoreanBrand(make: string) {
    switch(true) {
      case /daewoo|gm daewoo|gm korea|chevrolet/i.test(make.toLowerCase()): return '쉐보레';
      case /cadillac/i.test(make.toLowerCase()): return '캐딜락';
      default: return make.toUpperCase(); // GMC
    }
  }
}
